import WorkersCompensationClaimsHistory from "../../components/workersCompensationClaimsHistory/WorkersCompensationClaimsHistory";
import CargoClaimsHistory from "../../components/cargoClaimsHistory/CargoClaimsHistory";
import IPLClaimsHistory from "../../components/iplClaimsHistory/IPLClaimsHistory";
import { useAppSelector } from "src/redux/hooks";
import { RootState } from "src/redux/store";
import { LineOfBusiness } from "src/app/types";
import { Container, ContentLayout, Header, Tabs } from "@amzn/awsui-components-console";

/**
 * View for the Claims History Page.
 * @returns ClaimsHistory table component
 */
const ClaimsHistory = () => {
  const { lineOfBusiness } = useAppSelector((state: RootState) => state.app);
  const isCargo = lineOfBusiness === LineOfBusiness.CARGO;
  const isIPL = lineOfBusiness === LineOfBusiness.IPL;

  const tabs = [
    {
      label: "Search for Claims",
      id: "searchResults",
      content: isCargo ? (
        <CargoClaimsHistory showUserClaimsOnly={false} testId="cargo-claims-search-results" />
      ) : isIPL ? (
        <IPLClaimsHistory showUserClaimsOnly={false} testId="ipl-claims-search-results" />
      ) : (
        <WorkersCompensationClaimsHistory
          showUserClaimsOnly={false}
          testId="wc-claims-search-results"
        />
      ),
    },
  ];

  if (!isCargo && !isIPL) {
    tabs.push({
      label: "My Submitted Claims",
      id: "mySubmittedClaims",
      content: (
        <WorkersCompensationClaimsHistory
          showUserClaimsOnly={true}
          testId="wc-claims-search-results"
        />
      ),
    });
  }

  return (
    <ContentLayout disableOverlap={false} header={<Header variant="h1">Claims History</Header>}>
      <Container fitHeight>
        <Tabs fitHeight data-testid="claims-history-tabs" tabs={tabs} />
      </Container>
    </ContentLayout>
  );
};

export default ClaimsHistory;
